




















import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({})
export default class TextHeader extends Vue {
	@Prop()
	text: string;

	@Prop({type: Boolean, default: false})
	hideUnderline: boolean;
}
